import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";

const QuotationDetails = (props) => {
    const Data = useSelector(state => state.generateQuoteDetails);
    const quoteData = Data?.quote;
    const proposerDetails = quoteData?.proposer ?? {};
    const fallbackProposerName = `${proposerDetails?.proposer_title ?? "-"} ${proposerDetails?.proposer_first_name ?? "-"} ${proposerDetails?.proposer_last_name ?? ""}`.trim();
    const documentDetails = quoteData?.documentDetails ?? {};
    // Plan name removed per requirement; member premium shown as total premium
    const derivedMemberPremium = documentDetails?.member_premium ?? documentDetails?.total_premium ?? null;
    const memberPremium = props.memberPremiumOverride != null ? props.memberPremiumOverride : derivedMemberPremium;
    const planCost = memberPremium ?? 0; // Displayed as Total Premium
    const planCostCurrency = "INR";
    const quotationNumber = quoteData?.quotation_number ?? "--";

    // Responsive styles for one-line layout
    const isMobile = window.innerWidth <= 768;

    const itemStyle = {
        minWidth: "0",
        padding: isMobile ? "4px 6px" : "8px 12px",
        textAlign: "center",
        boxSizing: "border-box",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "nowrap",
        flex: "1 1 0",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    };

    const valueStyle = {
        fontSize: isMobile ? "13px" : "18px",
        fontWeight: 600,
        color: "#00239c",
        marginBottom: "2px",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden"
    };

    const labelStyle = {
        fontSize: isMobile ? "10px" : "13px",
        color: "#122040",
        opacity: 0.8,
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden"
    };

    return (
        <Fragment>
            <Row
                className="m-0 chart-main w-100"
                style={{
                    flexWrap: "nowrap",
                    background: "#e9eefc",
                    borderRadius: "12px",
                    padding: isMobile ? "6px 0" : "12px 0",
                    marginBottom: "18px",
                    justifyContent: "space-between",
                    overflowX: "auto"
                }}
            >
                <Col xl="3" md="6" sm="6" xs="12" className="p-0 box-col-6" style={itemStyle}>
                    <div className="media align-items-center custom-row-content text-center" style={{width: "100%"}}>
                        <div className="media-body" style={{width: "100%"}}>
                            <div className="right-chart-content" style={{width: "100%"}}>
                                <h5 className="custom-font text-center" style={valueStyle}>
                                    {props.quotationNumber ? props.quotationNumber : quotationNumber}
                                </h5>
                                <span className="custom-font1 text-center" style={labelStyle}>Quotation no</span>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xl="3" md="6" sm="6" xs="12" className="p-0 box-col-6" style={itemStyle}>
                    <div className="media align-items-center custom-row-content text-center" style={{width: "100%"}}>
                        <div className="media-body" style={{width: "100%"}}>
                            <div className="right-chart-content" style={{width: "100%"}}>
                                <h5 className="custom-font text-center" style={valueStyle}>
                                    {props.proposerName || fallbackProposerName}
                                </h5>
                                <span className="custom-font1 text-center" style={labelStyle}>Proposer</span>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xl="4" md="6" sm="6" xs="12" className="p-0 box-col-6" style={itemStyle}>
                    <div className="media align-items-center custom-row-content text-center" style={{width: "100%"}}>
                        <div className="media-body" style={{width: "100%"}}>
                            <div className="right-chart-content" style={{width: "100%"}}>
                                <h5 className="custom-font text-center" style={valueStyle}>
                                    {`${planCostCurrency} ${planCost}`}
                                </h5>
                                    <span className="custom-font1 text-center" style={labelStyle}>Total Fees</span>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
                        {/* Breakup removed since Total Premium equals Member Premium */}
        </Fragment>
    );
};

export default QuotationDetails;